import { FormEvent } from "react";
import { Form } from "react-bootstrap";
import { ITemplateFormData, ModalRequestType } from "./tabs/template-tab";

interface ITemplateModalContentProps {
  request_type: ModalRequestType | undefined;
  rowId: string | undefined;
  templateFormData: ITemplateFormData;
  validated: boolean;
  onFormDataChange: (data: ITemplateFormData) => void;
  onSubmit: (e?: FormEvent<HTMLFormElement>) => void;
}

const TemplateModalContent = ({
  request_type,
  rowId,
  templateFormData,
  validated,
  onFormDataChange,
  onSubmit,
}: ITemplateModalContentProps) => {
  if (!request_type || !rowId){
     return undefined;
  }

  const ConfirmForm = ({ label }: { label: React.ReactNode }) => (
    <Form noValidate onSubmit={onSubmit}>
      <Form.Group className="templateList-formGroup">
        <Form.Label>{label}</Form.Label>
      </Form.Group>
    </Form>
  );

  switch (request_type) {
    case "update_name":
      return (
        <Form noValidate validated={validated} onSubmit={onSubmit}>
          <Form.Group className="templateList-formGroup">
            <Form.Label>Template Name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Enter new template name"
              value={templateFormData.name || ""}
              onChange={(e) =>
                onFormDataChange({ ...templateFormData, name: e.target.value })
              }
            />
            <Form.Control.Feedback type="invalid">
              Please provide a template name.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="templateList-formGroup">
            <Form.Check
              type="checkbox"
              id="make-global"
              label="Global template"
              checked={!!templateFormData.is_global}
              disabled={!!(templateFormData.is_installation || templateFormData.sygno_default)}
              onChange={(e) => {
                const checked = e.target.checked;
                onFormDataChange({
                  ...templateFormData,
                  is_global:       checked,
                  is_installation: checked ? templateFormData.is_installation : false,
                });
              }}
            />
          </Form.Group>

          <Form.Group className="templateList-formGroup">
            <Form.Check
              type="checkbox"
              id="make-default"
              label="Installation default template"
              checked={!!templateFormData.is_installation}
              disabled={!templateFormData.is_global}
              onChange={(e) => {
                const checked = e.target.checked;
                onFormDataChange({
                  ...templateFormData,
                  is_installation: checked,
                  is_global:       checked ? true : templateFormData.is_global,
                });
              }}
            />
          </Form.Group>
        </Form>
      );

    case "assign_default":
      return (
        <ConfirmForm
          label={
            <p>
              Are you sure you want to{" "}
              {templateFormData.is_installation
                ? "unassign this template as installation default?"
                : "assign this template as installation default?"}
            </p>
          }
        />
      );

    case "assign_global":
      return (
        <ConfirmForm
          label={
            <p>
              Are you sure you want to{" "}
              {templateFormData.is_global
                ? "unassign this template as global template?"
                : "assign this template as global template?"}
            </p>
          }
        />
      );

    case "assign":
      return (
        <ConfirmForm
          label={
            <p>
              Are you sure you want to{" "}
              {templateFormData.current_tenant_default
                ? "unassign this template as tenant default?"
                : "assign this template as tenant default?"}
            </p>
          }
        />
      );

    case "unarchive":
      return (
        <ConfirmForm label="Are you sure you want to unarchive this template?" />
      );

    default:
      return undefined;
  }
};

export default TemplateModalContent;